import * as React from 'react';
import * as Redux from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Grid, Tooltip, Typography, Stack } from '@mui/material';
import {
  deleteTorneosAction,
  allTorneosAction,
  setActivoTorneosAction,
} from '../TorneosAction';
import * as CONST from '../../../../constants/FieldsConst';
import { LoadingWidget } from '../../../../widgets';
import { textLabels } from '../../../../helpers';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { Chip } from '@mui/material';
import ActionsListWidget from '../../../../widgets/ActionsList';
import { useNotification } from '../../../../helpers/Notification';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import ExpandedTorneosComponent from './ExpandedTorneos';
import { PARAMS_TORNEOS } from '../TorneosReducer';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import * as ROUTES from '../../../../router/Routes';

const ListadoTorneos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();
  let history = useHistory();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const torneosStore = Redux.useSelector((state) => state.torneos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...torneosStore.params,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_TORNEOS, payload });

      if (torneosStore.all && torneosStore.all.length === 0) {
        await allTorneosAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    torneosStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [torneosStore.all]);

  const _handleEditClick = async (id) => {
    const data = torneosStore.all.find((el) => el.id === id);
    await setActivoTorneosAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteTorneosAction(
      { dispatch, notify },
      torneosStore.activo.id,
      torneosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  function getDataStore(id) {
    return torneosStore.all.find((el) => el.id === id);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.equipos.name,
      label: CONST.equipos.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.fecha.name,
      label: CONST.fecha.tag,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.deporte.name,
      label: CONST.deporte.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoTorneosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  history.push(ROUTES.panelTorneos.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel del torneo"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  setActivoTorneosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = torneosStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedTorneosComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={torneosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {torneosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{torneosStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoTorneos;
